const mutations = {
  MUTATE_SORT(state, value) {
    state.sort = value;
  },

  MUTATE_DATE(state, value) {
    state.date = value;
  },

  MUTATE_SEARCH(state, value) {
    state.search = value;
  },

  MUTATE_ACTIVITY_LOGS(state, value) {
    state.logs = value;
  },

  MUTATE_ACTIVITY_LOGS_LOADING(state, value) {
    state.logsLoading = value;
  },

  MUTATE_ACTIVITY_LOGS_ERROR(state, value) {
    state.logsError = value;
  },

  MUTATE_SELECTED_LOGS(state, value) {
    state.selectedLogs = value;
  },

  // New mutations for transaction types
  MUTATE_CURRENT_TAB(state, value) {
    state.currentTab = value;
  },

  MUTATE_PAGINATION(state, value) {
    state.pagination = { ...state.pagination, ...value };
  },

  // Sticker transactions
  MUTATE_STICKER_TRANSACTIONS(state, value) {
    state.stickerTransactions = value;
  },
  MUTATE_STICKER_LOADING(state, value) {
    state.stickerLoading = value;
  },
  MUTATE_STICKER_ERROR(state, value) {
    state.stickerError = value;
  },

  // Stripe transactions
  MUTATE_STRIPE_TRANSACTIONS(state, value) {
    state.stripeTransactions = value;
  },
  MUTATE_STRIPE_LOADING(state, value) {
    state.stripeLoading = value;
  },
  MUTATE_STRIPE_ERROR(state, value) {
    state.stripeError = value;
  },

  // Benevity transactions
  MUTATE_BENEVITY_TRANSACTIONS(state, value) {
    state.benevityTransactions = value;
  },
  MUTATE_BENEVITY_LOADING(state, value) {
    state.benevityLoading = value;
  },
  MUTATE_BENEVITY_ERROR(state, value) {
    state.benevityError = value;
  },

  // Benevity W2W Credit transactions
  MUTATE_BENEVITY_W2W_TRANSACTIONS(state, value) {
    state.benevityW2WCreditTransactions = value;
  },
  MUTATE_BENEVITY_W2W_LOADING(state, value) {
    state.benevityW2WLoading = value;
  },
  MUTATE_BENEVITY_W2W_ERROR(state, value) {
    state.benevityW2WError = value;
  },
};

export default mutations;
